import DataTable from "react-data-table-component";
import { jsPDF } from "jspdf";
import autoTable from "jspdf-autotable";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faDownload, faX } from "@fortawesome/free-solid-svg-icons";

export default function ModalIndicatorDetails({ showModal, setShowModal, data }) {
    if (!showModal) return null;

    const columns = [
        {
            name: "Variable",
            selector: row => row.indicator,
            wrap: true,
            grow: 1,
            sortable: true,
        },
        {
            name: "Descripción",
            selector: row => row.description,
            wrap: true,
            grow: 2,
            sortable: true,
        },
    ];


    const exportToPDF = () => {
        const doc = new jsPDF("p", "mm", "a4");

        // Título
        doc.setFontSize(16);
        doc.text("Listado de Indicadores", 14, 15);

        // Preparar datos
        const tableRows = data.map(item => [
            item.indicator ?? "",
            item.description ?? "",
        ]);

        autoTable(doc, {
            startY: 25,
            head: [["Variable", "Descripción"]],
            body: tableRows,

            // Estilos generales
            styles: {
                fontSize: 9,
                cellPadding: 3,
                overflow: "linebreak",
            },

            // Header
            headStyles: {
                fillColor: [0, 122, 153],
                textColor: 255,
                halign: "center",
                fontStyle: "bold",
            },

            // Columnas
            columnStyles: {
                0: { cellWidth: 60 },
                1: { cellWidth: "auto" },
            },

            // Márgenes
            margin: { top: 25, left: 14, right: 14 },

            // Footer automático
            didDrawPage: ({ pageNumber }) => {
                doc.setFontSize(8);
                doc.text(
                    `Página ${pageNumber}`,
                    doc.internal.pageSize.width - 20,
                    doc.internal.pageSize.height - 10
                );
            },
        });

        doc.save("Detalles-de-las-variables-de-indicadores-medio-ambientales.pdf");
        setShowModal(false);
    };

    return (
        <div className="fixed inset-0 z-50 flex items-center justify-center w-full">
            {/* Overlay */}
            <div
                className="absolute inset-0 bg-black/40 backdrop-blur-sm"
                onClick={() => setShowModal(false)}
            />

            {/* Modal */}
            <div className="relative flex flex-col bg-white shadow-xl rounded-xl 
                            py-6 px-5 md:w-4/5 w-full 
                            max-h-[90vh] overflow-hidden
                            border border-gray-200 z-10">

                {/* Header */}
                {/* <div className="flex items-center justify-center p-4 bg-red-100 rounded-full">
                </div> */}

                <h2 className="text-gray-900 font-semibold mt-4 text-xl text-center">
                    Detalles de las Variables de Indicadores Medio Ambientales
                </h2>

                {/* CONTENIDO CON SCROLL */}
                <div className="mt-4 w-full flex-1 overflow-y-auto">
                    <DataTable
                        columns={columns}
                        data={data}
                        noDataComponent="No hay registros para mostrar"
                        highlightOnHover
                        striped
                        responsive
                        fixedHeader
                        fixedHeaderScrollHeight="400px"
                    />
                </div>

                {/* Footer */}
                <div className="flex items-center justify-center gap-4 mt-5 w-full">
                    <button
                        onClick={() => setShowModal(false)}
                        className="w-full md:w-36 h-10 rounded-md text-white bg-red-500 font-medium text-sm hover:bg-red-600"
                    >
                        Cerrar
                        <FontAwesomeIcon icon={faX} className="ml-2" />
                    </button>

                    <button
                        className="w-full md:w-36 h-10 rounded-md border border-gray-300 bg-[#007a99] text-white font-medium text-sm hover:bg-[#005f73]"
                        onClick={exportToPDF}
                    >
                        Descargar
                        <FontAwesomeIcon icon={faDownload} className="ml-2" />
                    </button>
                </div>
            </div>
        </div>
    );
}
